/**
 * Return Portal Content > Refund Methods: delegates save, discard, and dirty checks to
 * TranslationScopeStore via translationStore.loadScope (same instances as TranslationScope),
 * so the UI does not read the parent assistant scope from useTranslation by mistake.
 */

import translationStore from '../../../../../translation/stores/translations-store';
import TranslationScopeStore from '../../../../../translation/stores/translations-scope-store';
import dashboardSettingsStore from '../../../../../stores/dashboard-settings-store';
import { PROFILE_CAPABILITIES } from '../../../../../models/ProfileCapabilities';
import { getAllRefundMethodStaticTranslationKeys } from '../constants/refund-method-static-blocks';

class RefundMethodsContentStore {
    public translatableKeys(): string[] {
        const refundResolutionCapability = dashboardSettingsStore.resolveCapability(
            PROFILE_CAPABILITIES.REFUND_RESOLUTION
        );
        return getAllRefundMethodStaticTranslationKeys(
            refundResolutionCapability.supportedRefundTypes
        );
    }

    public resolveScope(enablePortalV2: boolean): 'portal-edge' | 'assistant' {
        return enablePortalV2 ? 'portal-edge' : 'assistant';
    }

    public hasChanges(scope: string): boolean {
        const scopeStore = translationStore.loadScope(scope) as TranslationScopeStore;
        return scopeStore.hasChanges(this.translatableKeys());
    }

    public save(scope: string): Promise<void> {
        return translationStore.loadScope(scope).save();
    }

    public discardChanges(scope: string): void {
        translationStore.loadScope(scope).discardChanges();
    }

    public isSaving(scope: string): boolean {
        return translationStore.loadScope(scope).isSaving();
    }
}

export default new RefundMethodsContentStore();
